import Uploader from './src/main';

export default Uploader;
